
    import useStore from '@/hooks/useStore'
    import useNavigation from '@/hooks/useNavigation'
    import useChat from '@/hooks/useChat'
    import websocket from '@/services/websocket/index'
    import { defineComponent, onMounted, onUnmounted, ref, reactive, SetupContext } from 'vue'

    import Modal from '@/components/Modal/ModalFactory.vue'
    import ChatHeader from '@/components/webchat/ChatHeader.vue'
    import ChatFooter from '@/components/webchat/ChatFooter.vue'
    import ChatReply from '@/components/webchat/ChatReply.vue'
    import ChatContent from '@/components/webchat/ChatContent.vue'
    import ChatForm from '@/components/webchat/ChatForm.vue'

    import services from '@/services'
    import { TModal } from '@/types/webchat'

    export default defineComponent({
        components: {
            Modal,
            ChatHeader,
            ChatFooter,
            ChatForm,
            ChatReply,
            ChatContent
        },

        emits: ['select-type', 'next', 'close-box'],
        props: {
            fixHeight: {
                type: Boolean,
                default: true
            }
        },
        setup (props, { emit }: SetupContext) {
            const store = useStore()

            const myFile = ref<HTMLInputElement | null>(null)

            const modal = reactive<TModal>({
                component: '',
                show: false
            })


            const {
                setErrorState,
                start
            } = useNavigation()

            const { finishChat, handleUpload } = useChat()

            const actionsFooter = [
                {
                    title: 'Enviar um documento',
                    icon: 'Append',
                    color: 'text-gray-400',
                    size: '20',
                    action: 'APPEND'
                }
                // {
                //   title: 'Finalizar Atendimento',
                //   icon: 'Logout',
                //   color: 'text-gray-400',
                //   size: '20',
                //   action: 'FINISH'
                // }
            ]

            let fetchMessagesAutomatic: number

            onMounted(async () => {
                fetchMessagesAutomatic = setInterval(async () => await services.webchat.fetchMessages(), 120000)

                await websocket.connectWs()

                await services.webchat.fetchMessages()
            })

            onUnmounted(() => clearInterval(fetchMessagesAutomatic))

            function handleModal (evt: string): void {
                switch (evt.toLowerCase()) {
                    case 'finish':
                        openFinish()
                        break

                    case 'cancel':
                        closeModal()
                        break

                    case 'closed':
                        openNewAttendance()
                        break

                    case 'new':
                        start()
                        closeModal()
                        break
                }
            }

            function handleAction (action: string): void {
                switch (action.toLowerCase()) {
                    case 'append':
                        myFile.value?.click()
                        break

                    case 'finish':
                        openDialogConfirmation()
                        break
                }
            }

            function handleSelect (): void {
                setErrorState()
            }

            function openFinish (): void {
                finishChat()
                modal.component = 'DialogFinish'
                modal.show = true
            }

            function openNewAttendance (): void {
                modal.component = 'DialogNewAttendance'
                modal.show = true
            }

            function openDialogConfirmation (): void {
                modal.component = 'DialogConfirmationFinish'
                modal.show = true
            }

            function closeModal (): void {
                modal.component = ''
                modal.show = false
            }

            async function onFileChanged (): Promise<void> {
                const file = myFile.value?.files?.[0]

                if (!file) return

                modal.component = 'DialogLoading'
                modal.show = true
                modal.bg = 'none'

                const payload = new FormData()
                payload.append('action', 'uploadImage')
                payload.append('file', file)
                payload.append('user', store.user)
                payload.append('apiKey', store.apiKey)
                await handleUpload(payload, file.type)

                modal.show = false
            }

            return {
                emit,
                props,
                store,
                modal,
                myFile,
                handleModal,
                handleAction,
                handleSelect,
                onFileChanged,
                actionsFooter
            }
        }
    })
